<template>
  <div class="thank-you text-center">
    <h1>{{ $t('thankYou.title') }}</h1>

    <p v-if="left">{{ $t('thankYou.webinarLeft') }}</p>
    <p v-else>{{ $t('thankYou.webinarEnded') }}</p>

    <p>
      <b-link v-if="!embed && debugMode" to="/">
        {{ $t('thankYou.joinAnother') }}
      </b-link>
    </p>

    <img v-if="!embed" class="watermark"
      :src="require('../../assets/goto-brand.svg')" />

    <nps-survey v-if="showNpsSurvey"></nps-survey>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import NpsSurvey from '@/components/nps-survey';
import { localStorage } from '@/utils/storage';

const ThankYou = {
  name: 'ThankYou',

  props: {
    left: {
      type: Boolean,
      default: false
    }
  },

  components: {
    NpsSurvey
  },

  mounted() {
    let simuliveQualtricsSurveyCount = localStorage.getItem("simulive_thank_you_visit") || 0;
    simuliveQualtricsSurveyCount++;
    localStorage.setItem("simulive_thank_you_visit", simuliveQualtricsSurveyCount)
    this.renderQualtricsSurvey()
  },

  methods: {
   renderQualtricsSurvey(){
      if(this.showQualtricsSurvey() && this.$store.state.g2wSession && this.$store.state.g2wSession.joinInfo){
        const joinInfo = this.$store.state.g2wSession.joinInfo;
        const surveyURL = new URL("https://feedback.goto.com/jfe/form/SV_eX4hAU9eQWSKmqi");
        if(joinInfo.participantId) {
          surveyURL.searchParams.set('participantId', joinInfo.participantId);
        }
        if(joinInfo.registrantKey) {
          surveyURL.searchParams.set('registrantKey', joinInfo.registrantKey);
        }
        if(joinInfo.eventKey) {
          surveyURL.searchParams.set('webinarKey', joinInfo.eventKey);
        }
        if(joinInfo.sessionKey) {
          surveyURL.searchParams.set('sessionKey', joinInfo.sessionKey);
        }
        const eventFile = joinInfo.eventFile;
        if(eventFile) {
          const assetData = eventFile.split("/");
          const assetKey = assetData[5];
          if(assetKey) {
            surveyURL.searchParams.set('assetKey', assetKey);
          }
        }
        const isCaptionsUsedOnce = this.$store.state.recording.isCaptionsUsedOnce
        if(isCaptionsUsedOnce) {
          surveyURL.searchParams.set('cc_enabled', isCaptionsUsedOnce);
        }
        localStorage.setItem("lastShown", Date.now());
        window.open(surveyURL)
      }
    },
   showQualtricsSurvey(){
      const isSurveyAvailable = this.$store.state.survey && this.$store.state.survey.surveyAvailability;
      const milliSecondsPerDay = 24 * 60 * 60 * 1000;
      const cooldownPeriodDays = 60;
      const simuliveQualtricsSurveyCount = localStorage.getItem("simulive_thank_you_visit") || 1;
      const isFourthIteration = (simuliveQualtricsSurveyCount % 4 === 0);
      const lastShown = localStorage.getItem("lastShown");
      const hasCooldownElapsed = lastShown
        ? ((Date.now() - lastShown)/ milliSecondsPerDay >= cooldownPeriodDays)
        : true;
      return !isSurveyAvailable && isFourthIteration && hasCooldownElapsed;
    },
  },

  computed: {
    organizerName() {
      return this.$store.state.g2wWebinar.webinarInfo.organizerName;
    },

    organizerEmail() {
      return this.$store.state.g2wWebinar.webinarInfo.organizerEmail;
    },

    organizerSurveyAvailability() {
      return (
        this.$store.state.survey
        && this.$store.state.survey.surveyAvailability
      );
    },

    showNpsSurvey() {
      return (
        this.npsMode !== 'never'
        && this.organizerSurveyAvailability === false
      );
    },

    ...mapState(['embed', 'debugMode', 'npsMode'])
  }
};

export default ThankYou;
</script>

<style lang="sass">
  .thank-you
    padding: 20px

    .email
      white-space: nowrap

    .watermark
      min-width: 200px
      max-width: 300px
</style>
